// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lAIue2fuWT8Pk5R9pB_M{padding-left:12px}.lAIue2fuWT8Pk5R9pB_M.HWLczQHSagskDUjNxxXf{padding:8px}.cD_HZu1hXUxkt6DOkqPY{border-radius:6px;align-items:center;display:flex}.cD_HZu1hXUxkt6DOkqPY .U70tg1ralgkeReYK2SSp{flex-wrap:wrap;align-items:center;gap:8px;display:flex}.cjRS7Yzj4IAQVAhrcH9O{color:var(--content-primary-primary);border:none;padding:0;font-size:13px;font-weight:400}.cjRS7Yzj4IAQVAhrcH9O:focus{outline:none}.cjRS7Yzj4IAQVAhrcH9O::placeholder{color:var(--content-primary-disabled)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `lAIue2fuWT8Pk5R9pB_M`,
	"witchValues": `HWLczQHSagskDUjNxxXf`,
	"multiList": `cD_HZu1hXUxkt6DOkqPY`,
	"placeholderWrap": `U70tg1ralgkeReYK2SSp`,
	"searchInput": `cjRS7Yzj4IAQVAhrcH9O`
};
export default ___CSS_LOADER_EXPORT___;
